// 域名定制网页配置参数
import LYCom from "../../../static/js/LYCom";

const eduWebConfig = {
    namespaced: true,
    state: {
        eduWebConfigInfo: null, // 当前教育局信息
        eudList: [{
                webId: 1,
                webName: '心海蓝韵',
                orgName: '心理健康消防平台',
                realmName: 'https://sxxf.lanyunxinli.cn' // 域名地址
            },

            {
                webId: 2,
                webName: '心海蓝韵',
                orgName: '心理健康公安平台',
                realmName: 'https://police.lanyunxinli.cn' // 域名地址
            },

        ]
    },
    mutations: {
        // 通过域名地址获取教育局配置信息
        getEduWebConfigInfo(state) {
            let currentHref = window.location.href.split('lanyunxinli.cn'); // 获取当前网页地址
            if (currentHref[0].indexOf('http://localhost') == -1) {
                currentHref = currentHref[0] + 'lanyunxinli.cn'; // 获取当前域名
            } else {
                currentHref = "https://police.lanyunxinli.cn"
            }
            let currentEdu = state.eudList.find(e => e.realmName == currentHref); // 通过域名获取
            if (currentEdu) {
                document.title = currentEdu.webName + currentEdu.orgName;
                state.eduWebConfigInfo = currentEdu;
            }
        },

    },
}

export default eduWebConfig



// WEBPACK FOOTER //
// ./src/store/modules/eduwebconfig.js